import { Pipe, PipeTransform } from '@angular/core';
import { timeConvert } from '@app-helpers/functions';

@Pipe({
  name: 'secondstohour'
})
export class SecondstohourPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    console.log("🚀 ~ file: secondstohour.pipe.ts:10 ~ SecondstohourPipe ~ transform ~ value", value)
    return timeConvert(value);
  }

}
